module.exports = __webpack_public_path__ + "static/media/netflix-logo.a1f673e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/netflix-logo.png
// module id = 607
// module chunks = 0